import React from "react";
import styled from "styled-components";

const ButtonStyled = styled.button`
  border-radius: 5px;
  border: none;
  color: white;
  padding: 7px 20px;
  font-size: 16px;
  cursor: pointer;
`;

export const PrimaryButton = styled(ButtonStyled)`
  background-color: ${({ theme }) => theme.colors.blue};
  ${({ $large }) =>
    $large &&
    `
      min-height: 48px;
      font-size: 1.1rem;
      width: 100%;
    `}
  &:hover {
    background-color: ${({ theme }) => theme.colors.blueHover};
  }
  &:disabled {
    opacity: 0.3;
    cursor: default;
    &:hover {
      background-color: ${({ theme }) => theme.colors.blue};
    }
  }
`;

export const DangerButton = styled(ButtonStyled)`
  background-color: ${({ theme }) => theme.colors.orange};
`;

const BtnWrapper = styled.div`
  margin-top: 40px;
`;

export const CTAButton = ({ children, handleClick, ...props }) => {
  return (
    <BtnWrapper onClick={handleClick}>
      <PrimaryButton {...props}>{children}</PrimaryButton>
    </BtnWrapper>
  );
};
